import main from 'views/main'

const loginRouter = {
  path: '/login',
  name: 'login',
  meta: {
    title: '登录'
  },
  component: (resolve) => {
    import('views/login').then((module) => {
      resolve(module)
    })
  }
}

const page404 = {
  path: '*',
  name: 'error-404',
  meta: {
    title: '页面不存在'
  },
  component: () => import('views/error-page/404.vue')
}

const page500 = {
  path: '/500',
  meta: {
    title: '服务端错误'
  },
  name: 'error-500',
  component: () => import('views/error-page/500.vue')
}

const printRouter = {
  path: '/print/:insid',
  name: 'print',
  meta: {
    title: '打印'
  },
  component: (resolve) => {
    import('views/workflow/print').then((module) => {
      resolve(module)
    })
  }
}
// 流程详情
const flowdetail = (resolve) => { import('views/workflow/wkfldetail').then((module) => { resolve(module) }) }
const taskdetail = (resolve) => { import('views/task/taskdetail').then((module) => { resolve(module) }) }
// 岗位成员,岗位管理 都用
const Member = (resolve) => { import('views/deptset/deptmember').then((module) => { resolve(module) }) }
// 档案详情,岗位管理 操作都用
const AchiveDetail = (resolve) => { import('views/archive/archive_detail').then((module) => { resolve(module) }) }
const Toarchive = (resolve) => { import('views/archive/archive_toarchive').then((module) => { resolve(module) }) }
// 制度 审批 approval
const institutionapproval = (resolve) => { import('views/institution/institution_approval').then((module) => { resolve(module) }) }

// 操作菜单
export const operateMenus = [
  { path: 'message', name: 'message', meta: { title: '消息', icon: 'icon-xiaoxi', isplugin: false }, component: (resolve) => { import('views/message/message').then((module) => { resolve(module) }) } },
  // { path: 'pending', name: 'pending', meta: { title: '待处理', icon: 'icon-dai', isplugin: false }, component: (resolve) => { import('views/pending/pending').then((module) => { resolve(module) }) } },
  // { path: 'task', name: 'task', meta: { title: '任务', icon: 'icon-task', isplugin: false }, component: (resolve) => { import('views/task/task').then((module) => { resolve(module) }) } },
  { path: 'sixS', name: 'sixS', meta: { title: '6S', icon: 'icon-task', isplugin: false }, component: (resolve) => { import('views/sixS/sixS').then((module) => { resolve(module) }) } },
  // { path: 'task', name: 'task', meta: { title: '任务', icon: 'icon-task', isplugin: false }, component: (resolve) => { import('views/taskNew/taskMainNew').then((module) => { resolve(module) }) } },
  { path: 'workflow', name: 'workflow', meta: { title: '流程', icon: 'icon-qizi', isplugin: false }, component: (resolve) => { import('views/workflow/workflow_list').then((module) => { resolve(module) }) } },
  { path: 'institution', name: 'institution', props: true, meta: { title: '制度', icon: 'icon-zhidu', isplugin: true }, component: (resolve) => { import('views/institution/institution_list').then((module) => { resolve(module) }) } },
  { path: 'institution/dept/select', name: 'institutionselectdept', props: true, meta: { title: '关联岗位' }, component: (resolve) => { import('views/components/selectdept').then((module) => { resolve(module) }) } },
  { path: 'archive', name: 'archive', meta: { title: '档案', icon: 'icon-dangan', isplugin: true }, component: (resolve) => { import('views/archive/archive_directory_list').then((module) => { resolve(module) }) } },
  { path: 'leave', name: 'leave', meta: { title: '请假', icon: 'icon-qingjia', isplugin: true }, component: (resolve) => { import('views/leave/source_leave').then((module) => { resolve(module) }) } },
  { path: 'reimbur', name: 'reimbur', meta: { title: '报销', icon: 'icon-baoxiao', isplugin: true }, component: (resolve) => { import('views/reimbur/reimbur').then((module) => { resolve(module) }) } }
]
// const depset = { path: 'depset', name: 'depset', meta: { title: '岗位管理', icon: 'icon-deptset', isplugin: false }, component: (resolve) => { import('views/deptset/deptlist').then((module) => { resolve(module) }) } }
import { hasPrivilege } from 'common/js/permission'

const setSixS = { path: 'setSixS', name: 'setSixS', meta: { title: '6S', icon: 'icon-rili', isplugin: false }, component: (resolve) => { import('views/setSixS/setSixS').then((module) => { resolve(module) }) } }
const post = { path: 'post', name: 'post', meta: { title: '岗位', icon: 'icon-deptset', isplugin: false }, component: (resolve) => { import('views/post/post').then((module) => { resolve(module) }) } }
const flowset = { path: 'flowset', name: 'flowset', meta: { title: '流程', icon: 'icon-flowset', isplugin: false }, component: (resolve) => { import('views/flowset/flowlist').then((module) => { resolve(module) }) } }
const pulginset = { path: 'pulginset', name: 'pulginset', meta: { title: '插件', icon: 'icon-chajian', isplugin: false }, component: (resolve) => { import('views/pluginset/pluginlist').then((module) => { resolve(module) }) } }
const member = { path: 'member/:id', name: 'member', meta: { title: '执行授权', icon: 'icon-member', isplugin: true }, component: Member }
const opauthset = { path: 'opauthset/:id', name: 'opauthset', meta: { title: '操作授权', icon: 'icon-auth', isplugin: true }, component: (resolve) => { import('views/opauthset/opauthlist').then((module) => { resolve(module) }) } }
const authList = { path: 'authset', name: 'authList', meta: { title: '管理授权', icon: 'icon-auth', isplugin: false }, component: (resolve) => { import('views/authset/auth_list').then((module) => { resolve(module) }) } }

export const setupMenus = [
  // depset,
  setSixS,
  post,
  flowset,
  pulginset,
  member,
  opauthset,
  authList
]
function getSetupMenus (userright) {
  // 按照要求，除了管理授权（authList）只给管理员，其他的直接放开
  let menus = [setSixS, post, flowset, pulginset, opauthset]
  if (userright === 1 || hasPrivilege('/auth/position/editPosition')) {
    menus.push(authList)
  }
  return menus
  /*
  let _archive = hasPrivilege('/auth/archive/*')
  switch (userright) {
    case 1:// 超级管理员
      return [setSixS, post, flowset, pulginset, opauthset, authList]
    case 2:// 公司操作管理人
      let munus = [setSixS, post, flowset, pulginset]
      return munus
    case 3:// 执行人
      if (_archive) {
        return [pulginset, post]
      }
      return [post]
    case 4:
      if (_archive) {
        return [pulginset]
      }
      return []
    case 5:
      if (_archive) {
        return [pulginset]
      }
      return []
    case 6:
      return [pulginset]
    default:
      break
  }
  return [
    setSixS,
    flowset,
    pulginset,
    opauthset
  ]
  */
}
const appRouter = [
  {
    path: '/',
    redirect: '/operate/message'
  },
  {
    path: '/operate',
    name: 'operate',
    meta: {
      title: '操作',
      icon: 'key'
    },
    component: main,
    children: [
      ...operateMenus,
      { path: 'task/taskTwo', name: 'taskTwo', meta: { title: '岗位任务详情' }, component: (resolve) => { import('views/taskNew/taskTwo').then((module) => { resolve(module) }) } },
      { path: 'task/taskMainNew', name: 'taskMainNew', meta: { title: '任务', icon: 'icon-task', isplugin: false }, component: (resolve) => { import('views/taskNew/taskMainNew').then((module) => { resolve(module) }) } },
      { path: 'task/daptdetail/:id', name: 'daptdetail', meta: { title: '岗位任务详情' }, component: (resolve) => { import('views/task/task_dept_detail').then((module) => { resolve(module) }) } },
      { path: 'task/check/:id', name: 'deptTaskCheck', meta: { title: '任务考核表' }, component: (resolve) => { import('views/task/check/task_check_main').then((module) => { resolve(module) }) } },
      { path: 'task/daptdetail/:id/:year/:month', name: 'daptdetailhistory', meta: { title: '岗位任务详情' }, component: (resolve) => { import('views/task/task_dept_history').then((module) => { resolve(module) }) } },
      { path: 'task/daptlist', name: 'companydaptlist', meta: { title: '任务' }, component: (resolve) => { import('views/task/task_dept_list').then((module) => { resolve(module) }) } },
      { path: 'task/taskScoreList', name: 'taskScoreList', meta: { title: '任务' }, component: (resolve) => { import('views/task/taskScore/taskScoreList').then((module) => { resolve(module) }) } },
      { path: 'task/taskHistoryScoreList', name: 'taskHistoryScoreList', meta: { title: '任务' }, component: (resolve) => { import('views/task/taskScore/taskHistoryScoreList').then((module) => { resolve(module) }) } },
      { path: 'task/add/:id?/:positionId?/:positionName?/:addType?/:dutyId?/:dutyName?', name: 'addtaskNew', meta: { title: '添加任务' }, component: (resolve) => { import('views/task/addtaskNew').then((module) => { resolve(module) }) } },
      { path: 'pending/add/:id?/:positionId?/:positionName?/:addType?/:dutyId?/:dutyName?', name: 'addtaskNewFromPending', meta: { title: '添加任务' }, component: (resolve) => { import('views/task/addtaskNew').then((module) => { resolve(module) }) } },
      { path: 'task/list/:year?/:month?', name: 'tasklist', meta: { title: '任务列表' }, component: (resolve) => { import('views/task/task_list').then((module) => { resolve(module) }) } },
      { path: 'task/history/:positionId', name: 'taskhistory', meta: { title: '历史评分' }, component: (resolve) => { import('views/task/history').then((module) => { resolve(module) }) } },
      { path: 'message/info/:noticeId', name: 'messageinfo', meta: { title: '消息详情' }, component: (resolve) => { import('views/message/message_detail').then((module) => { resolve(module) }) } },
      { path: 'task/detail/:id/:year?/:month?', name: 'taskdetail', meta: { title: '任务详情' }, component: taskdetail },
      { path: 'pending/detail/:id', name: 'taskListfromPending', meta: { title: '任务详情' }, component: taskdetail },
      { path: 'message/detail/:id', name: 'taskListfromMessage', meta: { title: '任务详情' }, component: taskdetail },
      { path: 'archive/add', name: 'archiveadd', meta: { title: '添加档案' }, component: (resolve) => { import('views/archive/archive_add').then((module) => { resolve(module) }) } },
      { path: 'archive/list', name: 'archivelist', meta: { title: '档案' }, component: (resolve) => { import('views/archive/archive_list').then((module) => { resolve(module) }) } },
      { path: 'archive/list_three', name: 'archivelistThree', meta: { title: '档案' }, component: (resolve) => { import('views/archive/archive_list_three').then((module) => { resolve(module) }) } },
      { path: 'archive/listDetail/:id', name: 'archivelistDetail', meta: { title: '档案详情' }, component: (resolve) => { import('views/archive/archive_listDetail').then((module) => { resolve(module) }) } },
      { path: 'archive/archive_search', name: 'archivesearch', meta: { title: '档案搜索' }, component: (resolve) => { import('views/archive/archive_search').then((module) => { resolve(module) }) } },
      { path: 'archive/add/directory', name: 'archivedirectory', meta: { title: '选择归档目录' }, component: (resolve) => { import('views/archive/archive_directory').then((module) => { resolve(module) }) } },
      { path: 'workflow/listtest', name: 'listtest', meta: { title: '测试' }, component: (resolve) => { import('views/workflow/list').then((module) => { resolve(module) }) } },
      { path: 'workflow/detail/:id/:type', name: 'wkfldetail', meta: { title: '流程详情' }, component: flowdetail },
      { path: 'pending/detail/:id/:type', name: 'wkfldetailfromPending', meta: { title: '流程详情' }, component: flowdetail },
      { path: 'message/detail/:id/:type', name: 'wkfldetailfromMessage', meta: { title: '流程详情' }, component: flowdetail },
      { path: 'message/message_toBeReviewed', name: 'toBeReviewedMessage', meta: { title: '待审核岗位' }, component: (resolve) => { import('views/message/message_toBeReviewed').then((module) => { resolve(module) }) } },
      { path: 'workflow/institutionapproval', name: 'institutionapproval', meta: { title: '制度审批' }, component: institutionapproval },
      { path: 'workflow/add', name: 'addwkfl', meta: { title: '添加流程' }, component: (resolve) => { import('views/workflow/addwkfl').then((module) => { resolve(module) }) } },
      { path: 'workflow/node/:insid/:id', name: 'wkflnode', meta: { title: '流程节点' }, component: (resolve) => { import('views/workflow/wkflnode').then((module) => { resolve(module) }) } },
      { path: ':type/detail/:id', name: 'archivedetail', meta: { title: '档案详情' }, component: AchiveDetail },
      { path: ':type/toarchive/:id', name: 'toarchive', meta: { title: '归档' }, component: Toarchive },
      { path: 'message/detail/:id', name: 'archivedetailfromMessage', meta: { title: '档案详情' }, component: AchiveDetail },
      { path: 'institution/add/:scope', name: 'institutionadd', meta: { title: '添加制度' }, component: (resolve) => { import('views/institution/institution_add').then((module) => { resolve(module) }) } },
      { path: 'reimbur/add', name: 'reimburadd', meta: { title: '添加明细' }, component: (resolve) => { import('views/reimbur/adddetail').then((module) => { resolve(module) }) } },
      { path: 'sixS/sixSAssessment', name: 'sixSAssessment', meta: { title: '年度考核' }, component: (resolve) => { import('views/sixS/sixSAssessment').then((module) => { resolve(module) }) } },
      { path: 'sixS/sixSAssess', name: 'sixSAssess', meta: { title: '6S考核表' }, component: (resolve) => { import('views/sixS/sixSAssess').then((module) => { resolve(module) }) } },
      { path: 'sixS/sixSUser', name: 'sixSUser', meta: { title: '6S考核表' }, component: (resolve) => { import('views/sixS/sixSUser').then((module) => { resolve(module) }) } },
      { path: 'sixS/setRemuneration', name: 'setRemuneration', meta: { title: '设置薪酬基数' }, component: (resolve) => { import('views/sixS/setRemuneration').then((module) => { resolve(module) }) } },
      { path: 'sixS/sixSRank', name: 'sixSRank', meta: { title: '生成月排名' }, component: (resolve) => { import('views/sixS/sixSRank').then((module) => { resolve(module) }) } }
    ]
  },
  {
    path: '/setup',
    name: 'setup',
    meta: {
      title: '设置',
      icon: 'key'
    },
    component: main,
    children: [
      ...setupMenus,
      { path: 'depset/add/:positionId?', name: 'adddept', meta: { title: '编辑岗位' }, component: (resolve) => { import('views/deptset/adddept').then((module) => { resolve(module) }) } },
      { path: 'depset/deptdisable/', name: 'deptdisable', meta: { title: '停用岗位' }, component: (resolve) => { import('views/deptset/deptdisable').then((module) => { resolve(module) }) } },
      { path: 'depset/flowdetail/:id/:type', name: 'wkfldetailfromDisable', meta: { title: '流程详情' }, component: flowdetail },
      { path: 'depset/taskdetail/:id', name: 'taskListfromDisable', meta: { title: '任务详情' }, component: taskdetail },
      { path: 'depset/search/:positionId?', name: 'deptsearch', meta: { title: '搜索' }, component: (resolve) => { import('views/deptset/serachme').then((module) => { resolve(module) }) } },
      { path: 'depset/proportion/:ratio/:itemIndex/:titleType/:positionId', name: 'proportion', meta: { title: '添加职责' }, component: (resolve) => { import('views/deptset/proportion').then((module) => { resolve(module) }) } },
      { path: 'depset/instity', name: 'deptinstity', meta: { title: '制度' }, component: (resolve) => { import('views/deptset/deptinstity').then((module) => { resolve(module) }) } },
      { path: 'depset/detail/:id', name: 'depsetarchivedetail', meta: { title: '档案详情' }, component: AchiveDetail },
      { path: 'depset/member/:id', name: 'detpmember', meta: { title: '执行授权' }, component: Member },
      { path: ':type/add', name: 'flowadd', meta: { title: '编辑流程' }, component: (resolve) => { import('views/flowset/flowadd').then((module) => { resolve(module) }) } },
      { path: ':type/node/add', name: 'nodeadd', meta: { title: '流程节点' }, component: (resolve) => { import('views/flowset/nodeadd').then((module) => { resolve(module) }) } },
      { path: ':type/dept/select', name: 'selectdept', props: true, meta: { title: '选择发起方' }, component: (resolve) => { import('views/components/selectdept').then((module) => { resolve(module) }) } },
      { path: 'pulginset/serachme/list', name: 'serachmelist', meta: { title: '报销类别' }, component: (resolve) => { import('views/pluginset/reimbur').then((module) => { resolve(module) }) } },
      { path: 'pulginset/directory/list', name: 'directorylist', meta: { title: '目录管理' }, component: (resolve) => { import('views/pluginset/directory').then((module) => { resolve(module) }) } },
      { path: 'pulginset/directoryFirst/list', name: 'directoryFirst', meta: { title: '目录管理' }, component: (resolve) => { import('views/pluginset/directoryFirst').then((module) => { resolve(module) }) } },
      { path: 'pulginset/directorySecond/list', name: 'directorySecond', meta: { title: '目录管理' }, component: (resolve) => { import('views/pluginset/directorySecond').then((module) => { resolve(module) }) } },
      { path: 'pulginset/setDayLog', name: 'setDayLog', meta: { title: '日志工作设置' }, component: (resolve) => { import('views/pluginset/setDayLog').then((module) => { resolve(module) }) } },
      { path: 'pulginset/flows', name: 'pulgflows', meta: { title: '报销模版' }, component: (resolve) => { import('views/pluginset/expenses').then((module) => { resolve(module) }) } },
      { path: 'opauthset/:id/opauthdetail/:number/:type', name: 'opauthdetail', meta: { title: '报销' }, component: (resolve) => { import('views/opauthset/opauthdetail').then((module) => { resolve(module) }) } },
      { path: 'opauthset/:id/opauthdetail/addopauth/:number/:type/:templatepartid', name: 'addopauth', meta: { title: '添加授权人' }, component: (resolve) => { import('views/opauthset/addopauth').then((module) => { resolve(module) }) } },
      { path: 'setSixS/dimensionalitySixS', name: 'dimensionalitySixS', meta: { title: '6S维度' }, component: (resolve) => { import('views/setSixS/dimensionalitySixS').then((module) => { resolve(module) }) } },
      { path: 'setSixS/checkRatioSixS', name: 'checkRatioSixS', meta: { title: '6S考核比例' }, component: (resolve) => { import('views/setSixS/checkRatioSixS').then((module) => { resolve(module) }) } },
      { path: 'post/postAdd', name: 'postAdd', meta: { title: '添加岗位' }, component: (resolve) => { import('views/post/postAdd').then((module) => { resolve(module) }) } },
      { path: 'post/executor', name: 'executor', meta: { title: '添加/编辑执行人' }, component: (resolve) => { import('views/post/executor').then((module) => { resolve(module) }) } },
      { path: 'post/toBeReviewed', name: 'toBeReviewed', meta: { title: '待审核岗位' }, component: (resolve) => { import('views/post/toBeReviewed').then((module) => { resolve(module) }) } },
      { path: 'authset/add', name: 'authAdd', meta: { title: '添加授权人' }, component: (resolve) => { import('views/authset/auth_add').then((module) => { resolve(module) }) } }
    ]
  }
]

export const routers = [
  loginRouter,
  page404,
  page500,
  printRouter,
  ...appRouter
]
export {
  getSetupMenus
}



// WEBPACK FOOTER //
// ./src/router/router.js